import { render, staticRenderFns } from "./NotificationsPopoverTaskTemplate.vue?vue&type=template&id=0fbd61ba&scoped=true&lang=pug"
import script from "./NotificationsPopoverTaskTemplate.vue?vue&type=script&lang=ts"
export * from "./NotificationsPopoverTaskTemplate.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsPopoverTaskTemplate.vue?vue&type=style&index=0&id=0fbd61ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd61ba",
  null
  
)

export default component.exports